export const BEFORE_SENDING = 3;
export const SENDING = 0;
export const SUCCESS = 1;
export const PRE_SEND = 2;
export const FAILURE = -1;